import React from 'react';
import { makeStyles } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';

export default function MessageContent(props) {
    const classes = useStyles();

    let iconColor = ""
    let icon = <React.Fragment></React.Fragment>
    let borderLeft=""
    switch (props.message.type) {
        case "warning":
            iconColor = "#F59128";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft="solid 8px rgb(245,145,39,0.2)"
            break;
        case "error":
            iconColor = "#D84949";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            borderLeft="solid 8px rgb(216,73,73,0.2)"
            break;
        case "maintenance":
            iconColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            borderLeft="solid 8px rgb(92,201,88,0.2)"
            break;
        default:
    }

    return (
        <div className={classes.messageContainer}>
            <div className={classes.dateTime}>
                {props.message.time}
            </div>
            <div className={classes.message} style={{borderLeft:borderLeft,height:props.messageHeight, backgroundColor:props.backgroundColor}}>
                <div className = {classes.icon} style = {{color:iconColor,paddingTop:props.iconPadding}}>{icon}</div>
                <div className={classes.text} style = {{width:props.textWidth}}>{props.message.type.charAt(0).toUpperCase() + props.message.type.substring(1,props.message.type.length) + " "+ props.message.machine + ": " + props.message.message}</div>
            </div>
        </div>
    )

}

const useStyles = makeStyles(() => ({
    icon:{
        float:"left",
        marginRight:"10px"
    },
    text:{
        float:"left",
        paddingTop:"3px"
    },
    message:{
        width:"100%",
        borderRadius:"6px",
        paddingTop:"10px",
        boxSizing:"border-box",
        paddingLeft:"10px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#020100',
    },
    dateTime:{
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: '#8D8D8D',
        marginTop:"10px"
    },   
}));